import React from "react";
import { ContextMenuProps } from "./types";
import { Menu } from "@mui/material";
import { ContextMenuContext } from "./context";
import { ContextMenuIconButton } from "./ContextMenuIconButton";

export const ContextMenu: React.FC<ContextMenuProps> = ({
  children,
  iconButton = <ContextMenuIconButton />,
  menuProps,
  consumerAnchorEl: testAnchorEl,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(
    testAnchorEl ?? null
  );

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event?: React.SyntheticEvent) => {
    event?.stopPropagation();
    setAnchorEl(null);
  };

  // Clone the provided IconButton and inject our onClick
  const iconButtonWithHandler = React.isValidElement(iconButton)
    ? React.cloneElement(iconButton as React.ReactElement<any>, {
        onClick: handleOpen,
      })
    : null;

  return (
    <>
      {iconButtonWithHandler}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        onClick={handleClose}
        {...menuProps}
      >
        <ContextMenuContext.Provider value={{ handleClose }}>
          {children}
        </ContextMenuContext.Provider>
      </Menu>
    </>
  );
};
